import { useEffect, useState } from 'react';
import {
  AppMobile,
} from '@vfit/shared/data-access';
import ClickToCall from './components/clickToCallEnergyCard/clickToCallEnergy';
import { IClickToCallCallMeBack } from './clickToCallEnergy.models';
import { ClickToCallCallMeBackTagging } from './clickToCallEnergy.tagging';
import { getErrorCmsByCode } from './clickToCallEnergy.utils';

const ClickToCallEnergy = ({
  clickToCallData,
  defaultNumber,
  cmsAppClickToCallChoice,
  handleClose,
  useAppActivation = true,
  isSubmittedForm,
  isSuccessForm,
  isErrorForm,
}: IClickToCallCallMeBack) => {
  const [isAppConfirmedActivation, setIsAppConfirmedActivation] = useState(
    useAppActivation ? !AppMobile.checkIsApp() : false
  );
  const [telephoneNumber, setTelephoneNumber] = useState(defaultNumber || '');
  const isSuccess = true
  const isError = false
  const isLoading = false
  const codeResponse = "200"


  const handleAppConfirmActivation = () => {
    setIsAppConfirmedActivation(true);
    // to do add logic to submit the telephone number
  };

  useEffect(() => {
    isSuccessForm?.(isSuccess);
  }, [isSuccess]);

  useEffect(() => {
    isErrorForm?.(isError);
  }, [isError]);

  return (
    <>
      {!defaultNumber && <ClickToCallCallMeBackTagging />}
      <ClickToCall
        clickToCallData={clickToCallData}
        setTelephoneNumber={setTelephoneNumber}
        isSuccess={isSuccess}
        isLoading={isLoading}
        isError={isError}
        defaultNumber={defaultNumber}
        handleClose={handleClose}
        onAppConfirmActivation={handleAppConfirmActivation}
        isAppConfirmedActivation={isAppConfirmedActivation}
        cmsAppClickToCallChoice={cmsAppClickToCallChoice}
        isSubmitted={(submitted: boolean) => isSubmittedForm?.(submitted)}
        cmsError={getErrorCmsByCode(
          clickToCallData?.clicktocall?.errorSubmission,
          codeResponse || ''
        )}
      />
    </>
  );
};

export default ClickToCallEnergy;
